import React from "react";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { addReview } from "../api";

import "./AddReview.css";

class AddReview extends React.Component {
  state = {
    userRating: "",
    titleReview: "",
    posReview: "",
    negReview: "",
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleFormSubmit = async (event) => {
    event.preventDefault();

    const { titleReview, posReview, negReview, userRating } = this.state;
    const { name, icon, hour, date } = this.props.location.place;
    const review = {
      titleReview,
      posReview,
      negReview,
      userRating,
      name,
      icon,
      hour,
      date,
    };
    await addReview(review);
    toast.dark(`You review was added successfully!`);
    this.props.history.push("/");
  };

  render() {
    const { titleReview, posReview, negReview, userRating } = this.state;
    return (
      <main className="box">
        <div className="backMenuBox">
          <NavLink to="/appointments">
            <img src="/images/back.png" />
          </NavLink>
          <h1>Add Review</h1>
        </div>

        <div className="totalAppointments">
          <section className="appointmentsBox">
            <div div className="appointmentsInfoBox">
              <div className="appointmentsBarBox" />
              <div className="appointmentsTextBox">
                <h2>{this.props.location.place.name}</h2>
                <p>{this.props.location.place.icon}</p>
              </div>
            </div>

            <div className="dateBox">
            <div className="dateBoxButtonBox"/>
            <div className="dateBoxTextBox">
              <p className="dateBoxTextBoxFix">{new Date(this.props.location.place.date).toDateString()}</p>
              <p className="dateHourBox">{this.props.location.place.hour}</p>
              </div>
            </div>
          </section>

          <form className="reviewFormBox" onSubmit={this.handleFormSubmit}>
            <div className="reviewFormTopBox">
              <div className="reviewFormTitle">
                <label>Title</label>
                <input
                  autocomplete="off"
                  type="text"
                  name="titleReview"
                  value={titleReview}
                  onChange={this.handleChange}
                />
              </div>

              <div className="reviewFormRating">
                <input
                  maxlength="1"
                  min="1"
                  max="5"
                  autocomplete="off"
                  type="number"
                  name="userRating"
                  value={userRating}
                  onChange={this.handleChange}
                />
                <img src="/images/star.png" />
              </div>
            </div>

            <div className="commentBox">
              <div className="commentBoxInput">
                <label>
                  <img src="/images/happyface.png" />
                </label>
                <input
                  autocomplete="off"
                  type="text"
                  name="posReview"
                  value={posReview}
                  onChange={this.handleChange}
                />
              </div>
              <div className="commentBoxInput">
                <label>
                  <img src="/images/sadface.png" />
                </label>
                <input
                  autocomplete="off"
                  type="text"
                  name="negReview"
                  value={negReview}
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="commentBoxButtonBox">
              <button className="commentBoxButton">Add</button>
            </div>
          </form>
        </div>
      </main>
    );
  }
}

export default AddReview;
